"use client";
import { Text as e } from "../../atoms/Text/Text.mjs";
import { Badge as t } from "../../atoms/Badge/Badge.mjs";
import { RadioGroupItem as n } from "../../atoms/RadioGroupItem/RadioGroupItem.mjs";
import { useId as r, useState as i } from "react";
import { twMerge as a } from "tailwind-merge";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import * as c from "@radix-ui/react-radio-group";
//#region src/components/molecules/RadioGroup/RadioGroup.tsx
var l = ({ className: l, options: u, onSelect: d }) => {
	let f = u.find((e) => e.selected)?.id || null, [p, m] = i(f), h = r();
	return /* @__PURE__ */ o(c.Root, {
		"data-slot": "radio-group",
		"aria-label": "Radio Group",
		className: a("grid gap-4 w-full", l),
		onValueChange: (e) => {
			m(e), d?.(e);
		},
		value: p,
		children: u.map(({ label: r, subLabel: i, rightLabel: c, badge: l, disabled: u, icon: d, calloutText: f, ctaText: m, onCtaClick: g, id: _ }, v) => {
			let y = `${h}-radio-${v}`;
			return /* @__PURE__ */ o("div", { children: /* @__PURE__ */ s("label", {
				htmlFor: y,
				className: a("block bg-white cursor-pointer ring-1 ring-gray-300 px-4 py-6 rounded-md relative", p === _ && "ring-blue-500 ring-2", u && "bg-gray-200 cursor-not-allowed"),
				children: [
					l && p === _ && /* @__PURE__ */ o(t, {
						size: "small",
						text: l,
						fontWeight: "semibold",
						className: "absolute -top-3 left-3 bg-blue-500 py-1"
					}),
					/* @__PURE__ */ s("div", {
						className: "flex justify-start gap-2 items-center",
						children: [
							/* @__PURE__ */ o(n, {
								value: _,
								id: y,
								disabled: u,
								checked: p === _
							}),
							/* @__PURE__ */ s("div", {
								className: "flex justify-start items-center ml-2",
								children: [d && /* @__PURE__ */ o("div", {
									className: a("inline-block w-[24px] mr-2 max-w-[24px] max-h-[24px] leading-[var(--text-base--line-height-mobile)] md:text-base-tablet md:leading-[var(--text-base--line-height-tablet)] lg:text-base lg:leading-[var(--text-base--line-height)]", u && "opacity-50"),
									children: d
								}), /* @__PURE__ */ o(e, {
									fontFamily: "polysans",
									fontSize: "sm",
									fontWeight: "semibold",
									className: a("font-semibold font-inter text-gray-950", u && "text-gray-500"),
									asChild: !0,
									children: /* @__PURE__ */ o("span", { children: r })
								})]
							}),
							c && /* @__PURE__ */ o(e, {
								fontFamily: "polysans",
								fontSize: "sm",
								fontWeight: "semibold",
								className: a("font-normal font-inter ml-auto", u && "text-gray-500"),
								asChild: !0,
								children: /* @__PURE__ */ o("span", { children: c })
							})
						]
					}),
					i && /* @__PURE__ */ o(e, {
						fontFamily: "polysans",
						fontSize: "xs",
						fontWeight: "regular",
						className: a("ml-8 mt-2 text-gray-900 font-normal font-inter", u && "text-gray-500"),
						children: /* @__PURE__ */ o("span", { children: i })
					}),
					(f || m) && /* @__PURE__ */ s("div", {
						className: "flex align-center justify-start ml-8 mt-2",
						children: [f && /* @__PURE__ */ s(e, {
							fontFamily: "polysans",
							fontSize: "base",
							fontWeight: "bold",
							className: "text-red-500",
							children: [/* @__PURE__ */ o("span", { children: f }), m && /* @__PURE__ */ o("span", {
								className: "ml-1 mr-1 d-block text-gray-900",
								children: "•"
							})]
						}), m && /* @__PURE__ */ o(e, {
							fontFamily: "polysans",
							fontSize: "base",
							fontWeight: "bold",
							className: "text-blue-500",
							children: /* @__PURE__ */ o("button", {
								onClick: g,
								className: "cursor-pointer",
								children: m
							})
						})]
					})
				]
			}) }, _);
		})
	});
};
l.displayName = "RadioGroup";
//#endregion
export { l as RadioGroup };
